import React, { Component } from 'react';
import _ from 'lodash';

import BackButton from '../lib/BackButton';
import CandidateDetail from '../lib/CandidateDetail';
import Dropdown from '../lib/Dropdown';
import { sortCandidates } from '../lib/sorting';
import { NEIGHBORHOODS, PARTIES } from '../lib/lookup-tables';
import '../../scss/RacesToWatch.scss';

export default class RacesToWatch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: { value: 'Mayor', label: 'Mayor'}
    };
  }
  
  changeDistrict(selected) {
    this.setState({ selected });
  }
  
  render() {
    let { races } = this.props;
    let options = Object.keys(races).map(d => ({value: d, label: d.startsWith('d') ? NEIGHBORHOODS[d] : d}));
    let racesByParty = _.groupBy(races[this.state.selected.value], 'party');
    let value = this.state.selected.value;
    let label = value.startsWith('d') && `City Council District ${value.slice(1)} - `;
  
    return (
      <div className="RacesToWatch">
        <BackButton route='index' routeTo={this.props.route} />
        <h1 className="RacesToWatch__header">Races to Watch</h1>
          
        <div className="RacesToWatch__controls">
          <Dropdown
           options={options}
           onChange={this.changeDistrict.bind(this)}
           value={this.state.selected} />
         </div>
          
  
        <div className="RacesToWatch__body">
          {Object.keys(racesByParty).map((k, i) => {
            return (<div key={i}>
              <h2 className="RacesToWatch__subhead">{label}{PARTIES[k]} Party</h2>
              <ul className="RacesToWatch__candidates">
                {sortCandidates(racesByParty[k]).map((c, i) => <li key={i}><CandidateDetail candidate={c} issue='bio' /></li>)}
              </ul>
            </div>);
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/routes/RacesToWatch.js